import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {WhiteboardComponent} from './components/whiteboard/whiteboard.component';
import {StaffToolbarComponent} from './components/toolbar/staff-toolbar/staff-toolbar.component';
import {StudentToolbarComponent} from './components/toolbar/student-toolbar/student-toolbar.component';
import {ObserverToolbarComponent} from './components/toolbar/observer-toolbar/observer-toolbar.component';
import {SVGModule} from '@app/modules/svg/svg.module';
import {FormsModule} from '@angular/forms';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {ColorPickerModule} from '@iplab/ngx-color-picker';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AssignmentComponent} from '@app/modules/whiteboard/components/assignment/assignment.component';
import {SharedModule} from '@app/modules/shared/shared.module';
import { WhiteboardMenusComponent } from './components/whiteboard/menus/whiteboard-menus.component';
import {
  PrivateWhiteboardComponent
} from '@app/modules/whiteboard/components/whiteboard/private/private-whiteboard.component';
import {ReportComponent} from '@app/modules/whiteboard/components/report/report.component';
import {MatSelectModule} from '@angular/material/select';

@NgModule({
  declarations: [
    WhiteboardComponent,
    PrivateWhiteboardComponent,
    StaffToolbarComponent,
    StudentToolbarComponent,
    ObserverToolbarComponent,
    AssignmentComponent,
    ReportComponent,
    WhiteboardMenusComponent
  ],
  exports: [
    WhiteboardComponent,
    PrivateWhiteboardComponent,
    StaffToolbarComponent,
    StudentToolbarComponent,
    ObserverToolbarComponent,
    AssignmentComponent,
    WhiteboardMenusComponent,
    ReportComponent
  ],
  imports: [
    CommonModule,
    SVGModule,
    FormsModule,
    NgbDropdownModule,
    ColorPickerModule,
    BrowserAnimationsModule,
    SharedModule,
    MatSelectModule
  ]
})
export class WhiteboardModule { }
